import apiClient from './client';
import { getAllPages } from './pagination';

// A comment is {id, body, like_count, liked_by_me, flag_counts, created_by, mine}.
// `targetKind` is one of TARGET_KINDS (constants/targetKinds.js).

// Top-level comments on a target
export const getComments = (targetKind, id) => getAllPages(`/${targetKind}/${id}/comments`);

export const getReplies = (commentId) => getAllPages(`/comments/${commentId}/replies`);

export const createComment = (targetKind, id, body) =>
  apiClient.post('/comments', { target: { kind: targetKind, id }, body }).then((r) => r.data);

// A reply goes on its parent's target
export const createReply = (parentId, body) =>
  apiClient.post('/comments', { parent_id: parentId, body }).then((r) => r.data);

export const updateComment = (id, body) =>
  apiClient.patch(`/comments/${id}`, { body }).then((r) => r.data);

// Deletes its replies too
export const deleteComment = (id) => apiClient.delete(`/comments/${id}`).then(() => undefined);
